"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DataGridButton = require("./DataGridButton.styles");

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The DataGridButton allows us to have correctly formatted buttons appear within the dataGrid -
 * please use these instead of hand rolled buttons in the columns
 *
 * <br />
 *
 * This component is Exported for use within applications
 */
var DataGridButton = _react.default.memo(function (_ref) {
  var alignment = _ref.alignment,
      children = _ref.children,
      dataTestId = _ref.dataTestId,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react.default.createElement(_DataGridButton.StyledButton, {
    alignment: alignment,
    colorTheme: "primaryPseudo",
    buttonHeight: "medium",
    buttonWidth: "fitText",
    onClick: onClick,
    dataTestId: dataTestId
  }, children);
});

DataGridButton.propTypes = {
  /** Alignment prop to allow the button to align like the column, takes care of padding for you */
  alignment: _propTypes.default.oneOf(['right', 'center', 'left']),

  /** All children elements to appear within the button - treat it as a standard Cake button */
  children: _propTypes2.default.children.isRequired,

  /** Standard data test id hook for our test writers */
  dataTestId: _propTypes.default.string.isRequired,

  /** Function to execute on click event */
  onClick: _propTypes.default.func.isRequired
};
DataGridButton.defaultProps = {
  alignment: 'left'
};
var _default = DataGridButton;
exports.default = _default;